import { render, staticRenderFns } from "./OrganismLoader.vue?vue&type=template&id=7057690f&"
import script from "./OrganismLoader.vue?vue&type=script&lang=js&"
export * from "./OrganismLoader.vue?vue&type=script&lang=js&"
import style0 from "./OrganismLoader.vue?vue&type=style&index=0&id=7057690f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomLoaderProject: require('/app/components/atoms/common/AtomLoaderProject.vue').default,AtomsCommonAtomLoaderLoadingBar: require('/app/components/atoms/common/AtomLoaderLoadingBar.vue').default})
